// Friendly generated names ("Amber Heron") so nobody has to type anything.

const ADJECTIVES = [
  "Amber", "Azure", "Cobalt", "Coral", "Crimson", "Dawn", "Dusk", "Ember", "Fern", "Frost",
  "Gilded", "Hazel", "Indigo", "Ivory", "Jade", "Juniper", "Lilac", "Lunar", "Marble", "Misty",
  "Moss", "Nimbus", "Obsidian", "Opal", "Pearl", "Quartz", "Rose", "Ruby", "Saffron", "Sage",
  "Silver", "Solar", "Tidal", "Topaz", "Umber", "Velvet", "Violet", "Willow", "Zephyr", "Aurora",
];

const CREATURES = [
  "Albatross", "Axolotl", "Badger", "Bat", "Beetle", "Cicada", "Crane", "Cricket", "Dolphin", "Firefly",
  "Fox", "Gecko", "Hare", "Heron", "Ibis", "Jellyfish", "Kestrel", "Koi", "Lark", "Lynx",
  "Manta", "Marten", "Moth", "Narwhal", "Nightjar", "Octopus", "Orca", "Otter", "Owl", "Pangolin",
  "Puffin", "Quail", "Raven", "Salamander", "Seal", "Sparrow", "Swift", "Tern", "Whale", "Wren",
];

/** 32-bit FNV-1a hash. */
export function hash32(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

export function nameFor(seed: string): string {
  const h = hash32(seed);
  return `${ADJECTIVES[h % ADJECTIVES.length]} ${CREATURES[(h >>> 8) % CREATURES.length]}`;
}

export function hueFor(seed: string): number {
  return hash32(seed + "#hue") % 360;
}

/** Small deterministic PRNG (mulberry32). */
export function rng(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
